import { formatter } from '../../src/javascript/phoneNumberFormatter.js'

$(document).ready(() => {
  const [accountPhoneInput, accountPhoneErrorMessage] = [
    document.querySelector("#account_phone_number") || document.querySelector("#account_accountable_attributes_phone_number"),
    document.querySelector("#account_phone_number_error_msg")
  ]

  if(accountPhoneInput) formatter(accountPhoneInput, accountPhoneErrorMessage);
});